import { useContext } from "react";
import StationContext from "../context/StationProvider";

const useStationData = () => {
    // eslint-disable-next-line
    const { stationData } = useContext(StationContext);
    return useContext(StationContext);
}

export default useStationData;